module.exports = __webpack_public_path__ + "static/media/background.e52115fd.jpg";